import {event, selectArr, hasClass, removeClass, addClass} from "../utils/utils";

export const lazyLoadShow = (image) => {
    removeClass(image,'lazy-load');
    if(image instanceof HTMLImageElement || image instanceof HTMLIFrameElement ) {
        image.src = image.getAttribute('data-src');
    } else {
        image.srcset = image.getAttribute('data-srcset');
    }
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
}

const fade = async () => {

    function showFades(animation) {
        let timeout = 0;
        [].slice.call(animation.childNodes).map(node => {
            if (node.className) {
                if (node.className.includes('fade')) {
                    if (timeout < 1) {
                        timeout += 100
                    } else {
                        timeout += 200
                    }

                    if(node.className.includes('img-container')) {
                        timeout += 500;
                    }

                    setTimeout(function () {
                        addClass(node,'in')
                    }, timeout)
                }
            }
        })
    }

    function animate() {
        let animations = selectArr(('.animate-fade'))

        animations.map(animation => {
            let bounding = animation.getBoundingClientRect();

            // If container height is higher than screen height
            if(bounding.height > (window.innerHeight || document.documentElement.clientHeight)) {
                if (bounding.top >= 0 && (bounding.bottom/2.5) <= (window.innerHeight || document.documentElement.clientHeight)) {
                    showFades(animation)
                }
            } else {
                if (bounding.top >= 0 && (bounding.bottom/1.8) <= (window.innerHeight || document.documentElement.clientHeight)) {
                    showFades(animation)
                }
            }

            if(hasClass(animation, 'animate-onload')) {
                showFades(animation)
            }
        })
    }

    event(window, 'scroll', animate)
    animate();
}

const lazyload = async () => {
    function display() {
        selectArr('.lazy-load').map(image => {
            let bounding = image.getBoundingClientRect(),
                top = bounding.top <= 115 && bounding.top > 0, //navbar height
                bottom = bounding.bottom > 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);

            if (top || bottom) {
                if (bounding.left >= 0 || image.parentNode.getBoundingClientRect().left >= 0) {
                    lazyLoadShow(image);
                }
            }
        });
    }

    event(window, 'scroll', display)
    display();
}

const initializer = () => {
    fade();
    lazyload();
}

export const Animate = {
    init: () => initializer(),
    lazyload: () => lazyload()
}
